import React from 'react';
import { Main, ArticleContainer } from '../styled/Container';
import { Heading2 } from '../styled/Heading';
import Head from './Head';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';

export interface ErrorData {
  message: string;
  title: string;
}

export default function Error({ errors, siteTitle }: { errors: ErrorData[]; siteTitle: string }) {
  return (
    <>
      <Head title="FEIL" siteTitle={siteTitle} status="red"></Head>
      <Main style={{ textAlign: 'left' }}>
        <ArticleContainer>
          <Heading2>Noe gikk galt</Heading2>

          {errors.map((errorData, index) => (
            <Alert severity="error" key={index}>
              <AlertTitle style={{ fontWeight: 'bold' }}>{errorData.title}</AlertTitle>
              {errorData.message}
            </Alert>
          ))}
        </ArticleContainer>
      </Main>
    </>
  );
}
